// extracted by css-extract-rspack-plugin
export default {"cls1":"session_trail-cls1_PJs","cls2":"session_trail-cls2_5Ja session_trail-cls1_PJs"};